/* Santas Vault - the photo uploader, and the record of what they were told.
   ------------------------------------------------------------------
   Tony's rule: state the file requirements, warn if the file misses them, and
   RECORD that warning on the order so nobody can come back later and say they
   did not know.

   The record is the point. It is written into a line item property, which means
   it lands on the order, the packing slip and the confirmation email, with the
   actual pixel dimensions in it. It is not a note in our system that we could
   have typed afterwards; it is on the customer's own receipt, in their copy.

   MEASURED IN THE BROWSER, BEFORE ANY UPLOAD. The file is read with
   createObjectURL and its natural dimensions taken from a decoded Image. That
   is the real pixel count, not the file size, which is what actually decides
   whether a print goes soft. A 6 MB photo can be 800 px wide and a 400 KB one
   can be 4000.

   IT NEVER BLOCKS THE SALE. A customer who wants their grandmother's scanned
   photograph on a blanket is allowed to have it. They are told, they tick, and
   the tick is on the invoice.
*/
(function () {
  function $(s, r) { return (r || document).querySelector(s); }

  function boot(root) {
    var MIN = parseInt(root.getAttribute('data-min'), 10) || 1500;
    // The ceiling. Above this the upload is slower than the shopper will wait
    // and Shopify's own 20 MB line item file limit starts refusing it.
    var MAX = parseInt(root.getAttribute('data-max'), 10) || 8000;
    var file = $('#sv-photo-file', root);
    var thumb = $('[data-photo-thumb]', root);
    var img = $('[data-photo-img]', root);
    var dims = $('[data-photo-dims]', root);
    var ok = $('[data-photo-ok]', root);
    var warn = $('[data-photo-warn]', root);
    var why = $('[data-photo-why]', root);
    var accept = $('[data-photo-accept]', root);
    var prop = $('[data-photo-prop]', root);
    var state = { w: 0, h: 0, name: '' };

    function form() {
      return root.closest('form') ||
             document.querySelector('form[action*="/cart/add"]');
    }
    function submitBtn() {
      var f = form();
      return f && f.querySelector('[type="submit"], .add-to-cart-button, button[name="add"]');
    }

    /* THE RULE CHANGED FROM WARN TO BLOCK, and Tony's words were: "for the
       image file we need to block an image if its not at the minimum specs or
       if its way over spec they will need to fix the image".

       The earlier version let a shopper tick a box and proceed with a photo
       we had told them was too small. That is defensible on paper and it is
       still a soft blanket, a complaint, a return and a refund, and the
       acknowledgement on the invoice does not get the customer their
       Christmas present. A file that cannot make a good print is now simply
       not accepted, and the shopper is told what to do about it.

       OVER SPEC IS ALSO BLOCKED, for a different reason: a 12,000 px original
       is a 40 MB upload that times out on a phone over mobile data, and
       Shopify's own line item file limit is 20 MB. Letting it through is
       letting the shopper wait for a failure. */
    function record() {
      var longest = Math.max(state.w, state.h);
      if (!state.w) { prop.value = ''; return; }
      if (longest >= MIN && longest <= MAX) {
        prop.value = state.w + ' x ' + state.h + ' px, within our ' + MIN +
                     ' to ' + MAX + ' px range';
      } else {
        prop.value = '';
      }
      gate();
    }

    /* No usable file, no sale. There is no tick to get past it any more. */
    var rightsEl = $('[data-photo-rights]', root), rightsProp = $('[data-photo-rightsprop]', root), rightsNeed = $('[data-photo-rightsneed]', root);
    var RIGHTS = 'Customer confirmed they own this image or have permission to print it, and accepted responsibility for its use (image rights wording v1, 24 Sep 2026)';
    function gate() {
      var longest = Math.max(state.w, state.h);
      var goodFile = state.w > 0 && longest >= MIN && longest <= MAX;
      var rightsOk = !!(rightsEl && rightsEl.checked);
      /* Image rights, 0.38.0: a good photo still waits for the tick, and the tick goes on the order. */
      if (rightsProp) { rightsProp.value = goodFile && rightsOk ? RIGHTS : ''; rightsProp.disabled = !(goodFile && rightsOk); }
      if (rightsNeed) rightsNeed.hidden = !(goodFile && !rightsOk);
      var b = submitBtn();
      if (!b) return;
      var blocked = (state.w > 0 && (longest < MIN || longest > MAX)) || (goodFile && !rightsOk);
      b.disabled = blocked;
      b.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      b.classList.toggle('is-blocked', blocked);
    }

    file.addEventListener('change', function () {
      var f = file.files && file.files[0];
      warn.hidden = true; ok.hidden = true; thumb.hidden = true;
      state = { w: 0, h: 0, name: '' };
      prop.value = '';
      accept.checked = false;
      if (!f) { gate(); return; }

      if (f.size > 20 * 1024 * 1024) {
        why.textContent = 'That file is over 20 MB, which Shopify will not accept. ' +
          'Most phones can export a smaller copy.';
        warn.hidden = false;
        return;
      }

      var url = URL.createObjectURL(f);
      var probe = new Image();
      probe.onload = function () {
        state.w = probe.naturalWidth;
        state.h = probe.naturalHeight;
        state.name = f.name;
        img.src = url;
        dims.textContent = state.w + ' x ' + state.h + ' pixels, ' +
                           (f.size / 1048576).toFixed(1) + ' MB';
        thumb.hidden = false;
        var longest = Math.max(state.w, state.h);
        if (longest >= MIN && longest <= MAX) {
          ok.textContent = 'Good to print. ' + longest + ' px on the long side, ' +
                           'inside our ' + MIN + ' to ' + MAX + ' px range.';
          ok.hidden = false;
        } else if (longest < MIN) {
          why.innerHTML = 'It is <strong>' + state.w + ' x ' + state.h +
            ' pixels</strong>, and we need at least ' + MIN + ' on the longest ' +
            'side, so this one is about ' + Math.round((1 - longest / MIN) * 100) +
            ' per cent short. Printed at blanket size it would look soft and ' +
            'grainy, so we will not print it.<br><br>' +
            '<strong>What usually fixes it:</strong> send the original from your ' +
            'camera roll rather than a copy. A photo saved from Facebook, ' +
            'Instagram or a text message has already been shrunk to about ' +
            '1,080 pixels by those apps and cannot be made bigger again. If the ' +
            'only copy you have is this one, an older photograph can sometimes ' +
            'be rescanned, and we are happy to look at it if you email us.';
          warn.hidden = false;
        } else {
          why.innerHTML = 'It is <strong>' + state.w + ' x ' + state.h +
            ' pixels</strong>, which is larger than we can accept. Anything over ' +
            MAX + ' px on the longest side is slower to upload than most phones ' +
            'will stay awake for, and it is past the file size the checkout will ' +
            'carry.<br><br><strong>What fixes it:</strong> most phones and photo ' +
            'apps have a "resize" or "choose size" option when you share or ' +
            'export a picture. Anything between ' + MIN + ' and ' + MAX +
            ' pixels prints beautifully.';
          warn.hidden = false;
        }
        record();
      };
      probe.onerror = function () {
        why.textContent = 'That file could not be read as an image. JPEG or PNG please.';
        warn.hidden = false;
        gate();
      };
      probe.src = url;
    });

    accept.addEventListener('change', record);
    if (rightsEl) rightsEl.addEventListener('change', gate);

    /* sv-multi.js intercepts the submit and posts JSON, which cannot carry a
       file. On a photo product it has to stand down so the native multipart
       submit runs, and it does that by seeing this flag on the form. */
    var f = form();
    if (f) f.setAttribute('data-sv-native', '1');
    gate();
  }

  function start() {
    var r = document.querySelector('[data-sv-photo]');
    if (r && !r.dataset.svOn) { r.dataset.svOn = '1'; boot(r); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
  document.addEventListener('shopify:section:load', start);
})();

/* ===========================================================================
   THE LIVE PREVIEW, and the lettering colour that feeds it.

   Tony: "DOG BLANKETS EXAMPLE CAN WE GENERATE A LIVE PREVIEW AS SUCH WITH
   THEIR IMAGE UPLOADED?"

   THE RULE THIS FOLLOWS. The canvas draws the same geometry as
   tools/photo_flat.flat(), because a preview drawn to a different layout from
   the print file is a picture of a product the customer will not receive. Every
   proportion below is the Python's, copied. If one moves, both move.

   IT REDRAWS ON FOUR THINGS: the photo, the name, the lettering colour and the
   SIZE, because the three blankets are not the same proportion. 30x40 and 60x80
   are 3:4 and the 50x60 is 5:6, so the same photo and the same name sit
   differently on each, and the shopper should see that before they pay rather
   than after.

   THE FONTS HAVE TO BE LOADED FIRST. Canvas fillText with a face the browser
   has not fetched silently substitutes a system font, so the preview shows
   Helvetica where the press will print Luckiest Guy. document.fonts.load is
   awaited and the canvas redrawn, rather than assuming the <link> in head has
   finished.
   ======================================================================== */
(function () {
  var PINE = '#0E2B22', BRASS = '#C2A049', BONE = '#F3EDE1', CREAM = '#FBF9F4';

  /* THE BORDER, mirrored from tools/photo_flat.BORDERS. The preview and the
     press file have to be the same object drawn twice, so if a colour is added
     to one it is added to the other in the same commit. Ground, mount, and the
     sub-line ink, because a light ground printed the old cream sub line cream
     on cream. */
  var BORDERS = {
    'Deep pine':     { g: '#0E2B22', m: '#C2A049', s: '#F3EDE1' },
    'Christmas red': { g: '#7B1A1D', m: '#D4AF5A', s: '#F3EDE1' },
    'Midnight navy': { g: '#12223C', m: '#C6A85C', s: '#F3EDE1' },
    'Charcoal':      { g: '#1A1C1E', m: '#C6C6C6', s: '#F3EDE1' },
    'Warm bone':     { g: '#EEE8DC', m: '#A88538', s: '#5C503A' }
  };

  function lum(hex) {
    var h = String(hex).replace('#', '');
    if (h.length === 3) { h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2]; }
    var n = parseInt(h, 16);
    if (isNaN(n)) return 255;
    return ((n >> 16 & 255) * 299 + (n >> 8 & 255) * 587 + (n & 255) * 114) / 1000;
  }
  // Printify blueprint 993 placeholder dimensions, per variant. The key is the
  // Size option value exactly as it is written on the product.
  var ASPECT = {
    '76 x 102cm': 4724 / 6567,
    '127 x 152cm': 7990 / 9449,
    '152 x 203cm': 9449 / 12697
  };
  var DEFAULT_ASPECT = 4724 / 6567;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  // The same four faces sv-multi offers, keyed the same way. A shopper who
  // picks Script and sees Luckiest Guy in the preview has been shown a
  // product they are not buying, which is the one thing this preview exists
  // to prevent.
  var FACES = {
    Bold:   { css: '"Luckiest Guy", Impact, sans-serif', caps: true },
    Comic:  { css: '"Bangers", Impact, sans-serif',      caps: true },
    Script: { css: '"Great Vibes", cursive',                caps: false },
    Clean:  { css: '"Baloo 2", sans-serif',              caps: false }
  };

  var st = { img: null, name: '', ink: BRASS, sub: 'Christmas 2026',
             aspect: DEFAULT_ASPECT, face: FACES.Bold, border: 'Deep pine' };

  function root() { return $('[data-sv-photo]'); }
  function fig() { return $('[data-photo-preview]'); }
  function cv() { return $('[data-photo-canvas]'); }

  /* ------------------------------------------------------------------ size */
  function sizeNow() {
    var tag = document.getElementById('sv-variants');
    var form = document.querySelector('form[action*="/cart/add"]');
    var idEl = form && form.querySelector('[name="id"]');
    if (!tag || !idEl) return null;
    try {
      var data = JSON.parse(tag.textContent);
      var idx = -1;
      (data.options || []).forEach(function (o, i) {
        if (String(o.name).toLowerCase() === 'size') idx = i;
      });
      if (idx < 0) return null;
      var hit = (data.variants || []).filter(function (v) {
        return String(v.id) === String(idEl.value);
      })[0];
      return hit ? hit.options[idx] : null;
    } catch (e) { return null; }
  }

  /* ------------------------------------------------------------ text fitting
     The Python binary-searches the point size until the string fits the box.
     Same here, against measureText, so the two agree on where a long name
     breaks down to a smaller face. */
  function fit(ctx, text, family, maxW, maxH) {
    var lo = 6, hi = Math.floor(maxH * 1.6), best = 6;
    while (lo <= hi) {
      var mid = (lo + hi) >> 1;
      ctx.font = mid + 'px ' + family;
      var m = ctx.measureText(text);
      var h = (m.actualBoundingBoxAscent || mid * 0.72) +
              (m.actualBoundingBoxDescent || mid * 0.2);
      if (m.width <= maxW && h <= maxH) { best = mid; lo = mid + 1; }
      else { hi = mid - 1; }
    }
    return best;
  }

  function centre(ctx, text, family, cx, top, maxW, maxH, fill, ground) {
    if (!text) return;
    var px = fit(ctx, text, family, maxW, maxH);
    ctx.font = px + 'px ' + family;
    var m = ctx.measureText(text);
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    var y = top + (m.actualBoundingBoxAscent || px * 0.72);
    /* THE SAME MEASURED KEYLINE THE PRESS LAYS DOWN, and the same number.
       photo_flat._centre outlines the text when the ink and the ground are
       within 90 points of luma, which is what makes gold read on the Warm bone
       border. Drawing it here and not there, or there and not here, makes the
       preview a different product from the one that prints. */
    if (ground && Math.abs(lum(fill) - lum(ground)) < 90) {
      ctx.lineJoin = 'round';
      ctx.miterLimit = 2;
      ctx.lineWidth = Math.max(2, px * 0.11);
      ctx.strokeStyle = lum(fill) > 150 ? '#0E161C' : '#FCFAF5';
      ctx.strokeText(text, cx, y);
    }
    ctx.fillStyle = fill;
    ctx.fillText(text, cx, y);
  }

  function rr(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  /* ----------------------------------------------------------------- draw */
  function draw() {
    var c = cv(); if (!c) return;
    var host = c.parentNode;
    var dpr = window.devicePixelRatio || 1;
    var cssW = Math.min(host.clientWidth || 520, 560) || 520;
    var cssH = Math.round(cssW / st.aspect);
    c.style.width = cssW + 'px';
    c.style.height = cssH + 'px';
    c.width = Math.round(cssW * dpr);
    c.height = Math.round(cssH * dpr);
    var ctx = c.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var W = cssW, H = cssH;

    var bd = BORDERS[st.border] || BORDERS['Deep pine'];
    ctx.fillStyle = bd.g;
    ctx.fillRect(0, 0, W, H);
    // the same soft centre lift the flat prints, so the fleece is not one slab
    var g = ctx.createRadialGradient(W / 2, H / 2, 0, W / 2, H / 2, Math.max(W, H) * 0.75);
    g.addColorStop(0, 'rgba(255,255,255,0.10)');
    g.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, H);

    var m = W * 0.085;
    var wx = m, wy = H * 0.085, ww = W - 2 * m, wh = H * 0.685 - H * 0.085;
    var pad = W * 0.016;

    ctx.fillStyle = bd.m;
    rr(ctx, wx - pad, wy - pad, ww + 2 * pad, wh + 2 * pad, W * 0.022);
    ctx.fill();
    ctx.fillStyle = CREAM;
    rr(ctx, wx, wy, ww, wh, W * 0.016);
    ctx.fill();

    if (st.img) {
      ctx.save();
      rr(ctx, wx, wy, ww, wh, W * 0.016);
      ctx.clip();
      // cover, exactly as the Python does: scale to fill, centre, crop
      var r = Math.max(ww / st.img.naturalWidth, wh / st.img.naturalHeight);
      var dw = st.img.naturalWidth * r, dh = st.img.naturalHeight * r;
      ctx.drawImage(st.img, wx + (ww - dw) / 2, wy + (wh - dh) / 2, dw, dh);
      ctx.restore();
    } else {
      ctx.strokeStyle = '#A89B84';
      ctx.lineWidth = Math.max(1, W * 0.004);
      var cx = wx + ww / 2, cy = wy + wh / 2, r1 = Math.min(ww, wh) * 0.13;
      rr(ctx, cx - r1 * 1.55, cy - r1 * 1.15, r1 * 3.1, r1 * 2.1, r1 * 0.2);
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(cx, cy + r1 * 0.03, r1 * 0.55, 0, Math.PI * 2);
      ctx.stroke();
      centre(ctx, 'YOUR PHOTO HERE', '"Baloo 2", sans-serif', cx,
             cy + r1 * 1.55, ww * 0.72, wh * 0.09, '#786E5C');
    }

    // A BLANK FIELD PRINTS NOTHING, so the placeholder has to read as a
    // placeholder. Drawn at a third opacity in the chosen ink rather than in
    // full strength, which would show a name the press is not going to set.
    var nm = st.name || 'YOUR NAME';
    ctx.save();
    if (!st.name) ctx.globalAlpha = 0.34;
    centre(ctx, st.face.caps ? nm.toUpperCase() : nm, st.face.css,
           W / 2, H * 0.745, W - 2 * m, H * 0.115, st.ink, bd.g);
    ctx.restore();
    centre(ctx, st.sub, '"Great Vibes", cursive',
           W / 2, H * 0.885, W * 0.62, H * 0.055, bd.s, bd.g);
  }

  /* ------------------------------------------------------------------ wire */
  function nameInput() { return $('.sv-name'); }

  /* ------------------------------------------------------------------------
     THE ONE THAT WOULD HAVE LOST EVERY PHOTO.

     `.sv-perso` is rendered by the personalisation snippet and it is NOT
     inside the /cart/add form. Measured, not assumed: on the live page
     `form.querySelector('.sv-perso')` is null. sv-multi never cared, because
     it intercepts the submit and posts JSON it has gathered from anywhere in
     the document. A NATIVE multipart submit does not work that way: a control
     outside the form is simply not sent. So the file input, the quality
     record and the lettering colour would all have been dropped, the order
     would have arrived with no photograph, and nothing anywhere would have
     said so.

     The fix is the HTML5 `form` attribute, which associates a control outside
     a form with it and submits it. It is applied rather than moving the block
     into the form, because moving it risks Horizon's own layout and sv-multi's
     assumptions for no gain. Re-applied on every refresh because `.sv-name` is
     built by sv-multi after this runs. */
  function adopt() {
    var f = document.querySelector('form[action*="/cart/add"]');
    if (!f) return;
    /* `f.id` IS NOT THE ID. A form exposes its named controls as properties on
       itself, and this form contains <input name="id"> for the variant, so
       `f.id` returns that INPUT. Setting form="[object HTMLInputElement]" on
       every control associated them with nothing, the native submit sent no
       properties, and the cart came back with {} - which looks exactly like
       "the shopper did not fill anything in". Read and write the ATTRIBUTE. */
    var fid = f.getAttribute('id');
    if (!fid) { fid = 'sv-cart-add-form'; f.setAttribute('id', fid); }
    ['#sv-photo-file', '[data-photo-prop]', '[data-photo-inkprop]',
     '[data-photo-borderprop]', '[data-photo-rightsprop]', '.sv-name']
      .forEach(function (sel) {
        $$(sel).forEach(function (el) {
          if (el.closest('form') !== f) el.setAttribute('form', fid);
        });
      });
  }

  function refresh() {
    var f = fig(); if (!f) return;
    adopt();
    f.hidden = false;
    var s = sizeNow();
    st.aspect = (s && ASPECT[s]) || DEFAULT_ASPECT;
    var n = nameInput();
    st.name = (n && n.value || '').trim();
    var picked = $('.sv-face input:checked');
    st.face = (picked && FACES[picked.value]) || FACES.Bold;
    var cap = $('[data-photo-cap]');
    if (cap) {
      cap.textContent = st.img
        ? 'Your blanket, as it will print' + (s ? ', ' + s : '')
        : 'Add a photo and a name and this preview fills in';
    }
    draw();
  }

  function start() {
    var r = root(); if (!r || r.dataset.svPv) return;
    r.dataset.svPv = '1';

    // the pet blanket says Merry Christmas under the name, the family one
    // says Christmas 2026. Read it off the handle rather than hard coding a
    // second template.
    if (/pet/.test(location.pathname)) st.sub = 'Merry Christmas';

    // A photo product is ONE photo on ONE line item, so the multi-name
    // quantity picker cannot do what it says. Hide it and renumber the steps
    // rather than leave a control that quietly does nothing.
    var perso = $('.sv-perso');
    if (perso) {
      perso.classList.add('sv-perso--photo');
      var steps = $$('.sv-perso__step', perso);
      steps.forEach(function (p) {
        var n = p.querySelector('span');
        if (!n) return;
        if (n.textContent.trim() === '2') {
          n.textContent = '3';
          // "Name for each" is written for six items on one form. There is one.
          p.innerHTML = n.outerHTML + ' The name underneath';
        }
      });
      var hint = perso.querySelector('.sv-perso__step--2 + .sv-perso__hint') ||
                 $$('.sv-perso__hint', perso).slice(-1)[0];
      if (hint) {
        hint.textContent = 'Whatever should sit under the photo. A name, a ' +
          'surname, a year. Leave it blank and the photo prints on its own, ' +
          'at the same price.';
      }
      // "the real artwork with your name set in it" is written for the design
      // range. Here the artwork is the shopper's own photograph.
      $$('.sv-perso__hint', perso).forEach(function (h) {
        if (/real artwork/i.test(h.textContent || '')) {
          h.textContent = 'The preview is drawn to the same layout the press ' +
            'prints, so what you see is what arrives.';
        }
      });
    }

    // move the preview to sit after the name field: artwork, size, colour,
    // wording, PREVIEW, add to cart.
    var f = fig();
    var items = document.getElementById('sv-items');
    if (f && items && items.parentNode) {
      items.parentNode.insertBefore(f, items.nextSibling);
    }

    $$('[data-photo-ink] .sv-photo__i').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-photo-ink] .sv-photo__i').forEach(function (o) {
          o.classList.toggle('is-on', o === b);
          o.setAttribute('aria-checked', o === b ? 'true' : 'false');
        });
        st.ink = b.getAttribute('data-ink');
        var p = $('[data-photo-inkprop]');
        if (p) p.value = b.getAttribute('data-ink-name');
        draw();
      });
    });

    $$('[data-photo-border] .sv-photo__i').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-photo-border] .sv-photo__i').forEach(function (o) {
          o.classList.toggle('is-on', o === b);
          o.setAttribute('aria-checked', o === b ? 'true' : 'false');
        });
        st.border = b.getAttribute('data-b-name');
        var p = $('[data-photo-borderprop]');
        if (p) p.value = st.border;
        draw();
      });
    });

    // the file input is owned by the block above; listen rather than reach in
    var file = $('#sv-photo-file');
    if (file) {
      file.addEventListener('change', function () {
        var fl = file.files && file.files[0];
        if (!fl) { st.img = null; refresh(); return; }
        var im = new Image();
        im.onload = function () { st.img = im; refresh(); };
        im.onerror = function () { st.img = null; refresh(); };
        im.src = URL.createObjectURL(fl);
      });
    }

    document.addEventListener('input', function (e) {
      if (e.target && e.target.classList &&
          e.target.classList.contains('sv-name')) refresh();
    });
    /* Horizon names its variant radios "Size-<hash>-<productid>", so a test
       for /option/ never matched and the preview kept the first size's shape
       whatever the shopper picked. Rather than guess at the naming, watch the
       form's own [name="id"] and redraw whenever it moves. That is the value
       that decides what is bought, so it cannot be the wrong thing to watch. */
    var lastId = null;
    function watchId() {
      var f = document.querySelector('form[action*="/cart/add"]');
      var el = f && f.querySelector('[name="id"]');
      var v = el ? el.value : null;
      if (v !== lastId) { lastId = v; refresh(); }
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && /^sv-face-/.test(t.name || '')) { setTimeout(refresh, 20); return; }
      watchId();
    });
    /* AND A POLL, because an event is not enough here. Horizon updates
       [name="id"] from a section render that comes back over the network, so a
       listener firing 40 ms after the click reads the OLD variant, records it
       as the current one and never looks again - which is exactly what
       happened: the cart took the 127 x 152 and the preview kept drawing the
       76 x 102. Reading one input's value four times a second cannot miss it
       and costs nothing. */
    setInterval(watchId, 250);
    window.addEventListener('resize', function () { clearTimeout(start._t); start._t = setTimeout(draw, 120); });

    refresh();
    if (document.fonts && document.fonts.load) {
      Promise.all([
        document.fonts.load('40px "Luckiest Guy"'),
        document.fonts.load('40px "Bangers"'),
        document.fonts.load('24px "Great Vibes"'),
        document.fonts.load('20px "Baloo 2"')
      ]).then(draw).catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 60); });
  } else { setTimeout(start, 60); }
  document.addEventListener('shopify:section:load', function () { setTimeout(start, 60); });
})();
